<template>
  <transition name="entity-drawer-fade">
    <div v-if="open" class="entity-drawer">
      <div class="entity-drawer__backdrop" @click="$emit('close')"></div>

      <aside class="entity-drawer__panel" role="dialog" aria-modal="true" :aria-label="title">
        <header class="entity-drawer__head">
          <div class="entity-drawer__heading">
            <p class="entity-drawer__eyebrow">
              {{ modeLabel }}
            </p>
            <h2 class="entity-drawer__title">
              {{ title }}
            </h2>
          </div>

          <button class="entity-drawer__close" type="button" aria-label="Cerrar" @click="$emit('close')">
            <i class="fa fa-times"></i>
          </button>
        </header>

        <div v-if="loading" class="entity-drawer__loading">
          Cargando formulario...
        </div>

        <section v-else class="entity-drawer__body">
          <slot />
        </section>
      </aside>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'EntityDrawer',
  props: {
    open: {
      type: Boolean,
      default: false
    },
    mode: {
      type: String,
      default: 'create'
    },
    title: {
      type: String,
      default: 'Editar'
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    modeLabel () {
      return this.mode === 'edit' ? 'Editar' : 'Crear'
    }
  }
}
</script>

<style scoped>
.entity-drawer {
  position: fixed;
  inset: 0;
  z-index: 700;
  display: flex;
  justify-content: flex-end;
}

.entity-drawer__backdrop {
  position: absolute;
  inset: 0;
  background: rgba(21, 17, 13, 0.46);
  backdrop-filter: blur(6px);
}

.entity-drawer__panel {
  position: relative;
  width: min(680px, 100vw);
  height: 100%;
  overflow-y: auto;
  z-index: 1;
  background:
    radial-gradient(circle at top right, rgba(232, 217, 196, 0.48), transparent 30%),
    linear-gradient(180deg, rgba(255, 252, 247, 0.99), rgba(246, 239, 231, 0.97));
  box-shadow: -24px 0 60px rgba(28, 22, 16, 0.14);
  border-left: 1px solid rgba(255, 255, 255, 0.55);
}

.entity-drawer__head {
  position: sticky;
  top: 0;
  z-index: 2;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  padding: 1.2rem 1.2rem 1rem;
  background: rgba(252, 249, 244, 0.86);
  backdrop-filter: blur(16px);
  border-bottom: 1px solid rgba(95, 76, 52, 0.08);
}

.entity-drawer__eyebrow {
  margin: 0 0 0.35rem;
  font-size: 0.72rem;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: rgba(58, 46, 33, 0.48);
}

.entity-drawer__title {
  margin: 0;
  color: #211913;
  font-size: 1.35rem;
  line-height: 1;
}

.entity-drawer__close {
  width: 2.3rem;
  height: 2.3rem;
  border: 1px solid rgba(102, 81, 57, 0.12);
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.72);
  color: #392d22;
  flex-shrink: 0;
}

.entity-drawer__body {
  padding: 1rem 1.2rem 1.3rem;
}

.entity-drawer__loading {
  padding: 1.2rem;
  color: rgba(45, 35, 26, 0.58);
}

.entity-drawer-fade-enter-active,
.entity-drawer-fade-leave-active {
  transition: opacity 0.18s ease;
}

.entity-drawer-fade-enter-from,
.entity-drawer-fade-leave-to {
  opacity: 0;
}

@media (max-width: 640px) {
  .entity-drawer__panel {
    width: 100vw;
  }

  .entity-drawer__head,
  .entity-drawer__body {
    padding-left: 1rem;
    padding-right: 1rem;
  }
}
</style>
